import { CmsRegistrationConfirmationPageHeader } from '../../models/registration-confirmation/cms-registration-confirmation-page.interface';

export const mockCmsRegistrationConfirmationPageHeader: CmsRegistrationConfirmationPageHeader =
  {
    registrationConfirmationPageTitle: "That's it, you’re all set!",
    registrationConfirmationPageSubtitle:
      'Registration and protection confirmed. We’ll send you a confirmation email shortly.',
  };
